import { connect } from 'react-redux';

import { getCurrentRepository } from 'src/selectors/repository-selectors';
import { getCurrentUser } from 'src/selectors/user-selectors';
import { BucketState } from 'src/types/state';

import EmptyState from '../components/empty-state';

const mapStateToProps = (state: BucketState) => {
  const repository = getCurrentRepository(state);
  const user = getCurrentUser(state);

  return {
    hasSshKey: user && user.extra ? user.extra.has_ssh_key : undefined,
    repository,
  };
};

export default connect(mapStateToProps)(EmptyState);
